import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
           click: {
                fontsize: 'fontsize',
                lineheight: 'lineheight',
                contrast: 'contrast',
                letterspacing: 'letterspacing',
                reset: 'reset',
            }
        }
        this.values ={
            fontsize : "",
            lineheight : "",
            contrast : "",
            letterspacing : ""
        }
        
    }

    init() {
        // Set existing settings
        for (const [property, value] of Object.entries(this.values)) {
            if (this.getSettings(property)){
                this.values[property] = this.getSettings(property)
                document.querySelector('#accessibility-vars').innerHTML += 'html{'+this.values[property]+'}'
                document.querySelector("html").classList.add('is-accessible-'+property)
            }
        }
    }

    // Save current settings in cookies
    saveSettings(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    // Reset all settings and delete cookies
    resetSettings() {
        var d = new Date();
        d.setTime(d.getTime() - (1 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        for (const [property, value] of Object.entries(this.values)) {
            if (this.getSettings(property)) {
                document.cookie = property + "=;" + expires + ";path=/";
            }
        }
        
    }

    // Get settings from cookies
    getSettings(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    fontsize(el) {
        this.setVariables(el,'font-size',16,'px');
    }
    lineheight(el) {
        this.setVariables(el, 'line-height', 1.15, '');
    }
    letterspacing(el) {
        this.setVariables(el, 'letter-spacing', 0.01, 'em');
    }
    contrast(el) {
        this.setVariables(el,'contrast',100,'%');
    }

    setVariables(el,cssAttribute,defaultValue,suffix) {
        let target = el.currentTarget;
        let htmlStyle = getComputedStyle(document.querySelector("html"));
        let dataName = cssAttribute.replace('-','');
        let currentValue = htmlStyle.getPropertyValue('--html-' + dataName);
        document.querySelector("html").classList.add('is-accessible-' + dataName);
        if(currentValue == ""){
            currentValue = defaultValue+suffix;
        }else{
            if (htmlStyle.getPropertyValue('--html-' + dataName)){
                currentValue = htmlStyle.getPropertyValue('--html-' + dataName);
            }
        }
        currentValue = currentValue.replace(suffix,'');
        currentValue = parseFloat(currentValue,2) + parseFloat(target.getAttribute('data-'+dataName),2);
        this.values[dataName] = '--html-' + dataName +':'+currentValue+suffix+' !important; ';
        let newCssDeclaration = "";
        for (const [property, value] of Object.entries(this.values)) {
            newCssDeclaration += value;
            this.saveSettings(property, value, 365);
        }   
        document.querySelector('#accessibility-vars').innerHTML = 'html{'+newCssDeclaration+'}';
    }

    // Reset all settings & destroy cookies
    reset() {
        document.querySelector("html").classList.remove('is-accessible-fontsize','is-accessible-lineheight','is-accessible-contrast','is-accessible-letterspacing');
        document.querySelector('#accessibility-vars').innerHTML = '';
        document.querySelector('.js-accessibility-nav').classList.remove('-theme-light');
        for (const [property, value] of Object.entries(this.values)) {
            this.values[property]="";
        }
        this.resetSettings()
    }
}
